import { ThunkDispatch } from "core-integration/src/store";
import { fetchMyTeam } from "core-integration/src/store/my-team/thunks";
import { getTransferState } from "core-integration/src/store/squad/reducers";
import React, { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createPageViewData } from "../../utils/tealium";
import ConfirmTransfersDialog from "./ConfirmTransfersDialog";
import { IListTableProps } from "./CreateSquad";
import SquadBase from "./SquadBase";
import TransfersListTable from "./TransfersListTable";

type Props = WithTranslation;

const Transfers: React.FC<Props> = ({ t }) => {
  const dispatch = useDispatch<ThunkDispatch>();

  const transfersState = useSelector(getTransferState);

  useEffect(() => {
    dispatch(fetchMyTeam());
    createPageViewData("transactions");
  }, []);

  // Don't render until we know what transfers staate we need to render ...
  if (!transfersState) {
    return null;
  }
  const scoreboard = transfersState.status === "cost" ? "cost" : "basic";

  return (
    <SquadBase
      contentTitle="transactions"
      showListTableAsDefault={true}
      listTable={(listTableProps: IListTableProps) => (
        <TransfersListTable {...listTableProps} />
      )}
      scoreboard={scoreboard}
      submitDialog={(handleHide: () => void) => (
        <ConfirmTransfersDialog handleHide={handleHide} />
      )}
      title={t("transfers.title", "Transactions")}
    />
  );
};

export default withTranslation()(Transfers);
